import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { Alert } from "reactstrap";

const ConfirmEmailPage = () => {
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const location = useLocation();

  useEffect(() => {
    // Grab the parameters Flask passed to us in the URL
    const params = new URLSearchParams(location.search);
    const success = params.get("success");
    const error = params.get("error"); // Flask-Security passes 'error' if the token fails

    if (success) {
      setSuccessMessage(success);
    } else if (error) {
      setErrorMessage(error);
    } else {
      setErrorMessage("No confirmation information found.");
    }
  }, [location.search]);

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h3>Account Confirmation</h3>

      {successMessage && (
        <Alert color="success">
          <i className="mdi mdi-check-circle me-2"></i>
          {successMessage}
          <br />
          <div className="mt-3">
            <Link to="/login" className="btn btn-success">
              Click here to log in
            </Link>
          </div>
        </Alert>
      )}

      {errorMessage && (
        <Alert color="danger">
          <i className="mdi mdi-block-helper me-2"></i>
          {errorMessage}
        </Alert>
      )}
    </div>
  );
};

export default ConfirmEmailPage;